import {createEntityAdapter} from '@reduxjs/toolkit';

/** @namespace Inventory.Adapters */

/**
 * CRUD adapter for handling Inventory Exceptions data within the store.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const inventoryExceptionsAdapter = createEntityAdapter();

/**
 * CRUD adapter for handling Inventory Blackouts data within the store.  Default is sorted by the  blackout ID (spotBlackoutId).
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const inventoryBlackoutsAdapter = createEntityAdapter({
    selectId: (blackout) => blackout.spotBlackoutId,
});

/**
 * CRUD adapter for handling Reccurring Monthly Inventory data within the store.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const recurringMonthlyAdapter = createEntityAdapter({
    selectId: (recurring) => recurring.id,
});

/**
 * CRUD adapter for handling Non-Reccurring Monthly Inventory data within the store.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const nonRecurringMonthlyAdapter = createEntityAdapter({
    selectId: (nonRecurring) => nonRecurring.id,
});
